module.exports = __webpack_public_path__ + "static/media/mapping-consumer-data-img-003.467cfe24.jpg";